/**
 * @Author: Nemo
 * @Description: 表单字段配置
 * @Date: 2024-11-30
 * @FilePath: /rhcn-checkout-web/src/common/config/field-config/field.js
 */

import EMAIL_OPTIONS from '@/utils/tools/email';

const queryEmailSearch = (queryString, cb) => {
  let results = [];
  try {
    const i = queryString.indexOf('@');
    if (i > -1 && i < queryString.length - 1) {
      results = EMAIL_OPTIONS.filter(item => item.value.includes(queryString.substring(i)))
        ?.map(item => ({ value: queryString.split('@')[0] + item.value }));
    }
  } catch (err) {
    //
  }
  cb(results);
};

// 支付信息配置
export const paymentFields = [
  {
    name: 'cardNum',
    label: 'message.checkout.cardInfo',
    renderComponent: 'CardInformationForm',
  },
  {
    name: 'effectiveDate',
    label: 'message.checkout.expiredDate',
    renderComponent: 'BaseInput',
    placeholder: 'MM/YY',
    maxLength: 5,
  },
  {
    name: 'cvv',
    label: 'message.checkout.cvv',
    renderComponent: 'BaseInput',
    maxLength: 4,
  },
  {
    name: 'cardHolderName',
    label: 'message.checkout.holderName',
    renderComponent: 'BaseInput',
    maxLength: 50,
    placeholder: 'message.checkout.holderNameTips',
    autocomplete: 'cc-name',
  },
  {
    name: 'identityNumber',
    label: 'message.checkout.identityNumber',
    renderComponent: 'BaseInput',
    maxLength: 64,
  },
  {
    name: 'birthDate',
    label: 'message.checkout.birthDate',
    renderComponent: 'BaseInput',
    placeholder: 'YYYY / MM / DD',
    maxLength: 14,
    inputHandler: 'birthDateChangeHandler',
  },
  {
    name: 'issueDate',
    label: 'message.checkout.issueDate',
    renderComponent: 'BaseInput',
    placeholder: 'MM/YY',
    maxLength: 5,
  },
  {
    name: 'blikcode',
    label: 'message.checkout.blikcode',
    renderComponent: 'BaseInput',
    maxLength: 6,
  },
  {
    name: 'walletAccountName',
    label: 'message.checkout.walletAccountName',
    renderComponent: 'BaseInput',
    maxLength: 50,
  },
  {
    name: 'bankName',
    label: 'message.checkout.bankName',
    renderComponent: 'BaseSelect',
  },
  {
    name: 'iBan',
    label: 'message.checkout.iBan',
    renderComponent: 'BaseInput',
    maxLength: 64,
  },
  {
    name: 'prepaidNumber',
    label: 'message.checkout.cardNumber',
    renderComponent: 'BaseInput',
    maxLength: 16,
    inputType: 'numeric',
  },
  {
    name: 'jpFirstName',
    /** 行字段组 */
    isRowFields: true,
    rowFields: [
      {
        name: 'jpFirstName',
        label: '姓/カタカナ',
        renderComponent: 'BaseInput',
        maxLength: 64,
      },
      {
        name: 'jpLastName',
        label: '名/カタカナ',
        renderComponent: 'BaseInput',
        maxLength: 64,
      },
    ],
  },
];

// 账单信息配置
export const billingFields = [
  {
    name: 'country',
    label: 'message.checkout.country',
    renderComponent: 'CountrySelect',
    /** 账单信息的国家下拉框是默认禁用 */
    disabled: true,
  },
  {
    name: 'province',
    label: 'message.checkout.province',
    renderComponent: 'BaseSelect', // 或者 'BaseInput' 根据国家动态调整
    maxLength: 64,
  },
  {
    name: 'address',
    label: 'message.checkout.address',
    renderComponent: 'BaseTextarea',
    maxLength: 256,
    resizable: false,
    customStyle: {
      padding: '5px 12px',
      height: '84px',
      minHeight: '84px',
    },
  },
  {
    name: 'city',
    label: 'message.checkout.city',
    renderComponent: 'BaseInput',
    maxLength: 64,
  },
  {
    name: 'postalCode',
    label: 'message.checkout.postalCode',
    renderComponent: 'BaseInput',
    maxLength: 32,
  },
  {
    name: 'email',
    label: 'message.checkout.email',
    renderComponent: 'BaseAutocomplete',
    autocomplete: 'email',
  },
  // 姓、名取巧处理
  // 并行显示，只显示左边的label，看起来效果就像是单行label
  {
    name: 'firstName',
    label: 'message.checkout.contactName',
    /** 行字段组 */
    isRowFields: true,
    rowFields: [
      {
        name: 'firstName',
        label: 'message.checkout.contactName',
        placeholder: 'message.checkout.firstName',
        renderComponent: 'BaseInput',
        maxLength: 64,
      },
      {
        name: 'lastName',
        placeholder: 'message.checkout.lastName',
        renderComponent: 'BaseInput',
        maxLength: 64,
      },
    ],
  },
  {
    name: 'phone',
    label: 'message.checkout.phone',
    renderComponent: 'BaseInput',
    maxLength: 32,
    inputType: 'numeric',
  },
  {
    name: 'street',
    label: 'message.checkout.street',
    renderComponent: 'BaseInput',
    maxLength: 64,
  },
  {
    name: 'number',
    label: 'message.checkout.number',
    renderComponent: 'BaseInput',
    maxLength: 64,
  },
  {
    name: 'periodValue',
    label: 'message.checkout.intallment',
    renderComponent: 'BaseSelect',
  },
];
